<template>
  <div class="d-flex align-items-center">
    <toggle-button
      v-model="listing.notify_marketing"
    >
    </toggle-button>
    <small class="d-inline-block ml-3">
      {{ listing.notify_marketing ? 'Marketing is notified of updates to price and status.' : 'Marketing is not notified of updates to price and status.' }}
    </small>
  </div>
</template>

<script>
import { notifyMarketing, stopNotifyingMarketing } from '@/api'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  components: {
    ToggleButton,
  },
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      listing: this.value,
      cropped: false
    }
  },
  watch: {
    'listing.notify_marketing' (value) {
      value ? notifyMarketing(this.listing.id) : stopNotifyingMarketing(this.listing.id)
    }
  },
}
</script>